import { render, staticRenderFns } from "./DynamicFormField.vue?vue&type=template&id=24c0ef56&scoped=true&"
import script from "./DynamicFormField.vue?vue&type=script&lang=ts&"
export * from "./DynamicFormField.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicFormField.vue?vue&type=style&index=0&id=24c0ef56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0ef56",
  null
  
)

export default component.exports